// modules/gerente/components/GerenciaLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
// import GerenciaNavbar from '../components/NavbarG'; // ⚠️ NAVBAR ANTIGUO - REEMPLAZADO POR SIDEBAR
import SidebarNav from '../../../components/SidebarNav';
import ErrorBoundary from '../../../components/ErrorBoundary';
import '../../../styles/SidebarNav.css';

const GerenciaLayout = () => {
    return (
        <ErrorBoundary>
            <div className="gerencia-layout" style={{ display: 'flex', minHeight: '100vh' }}>
                <SidebarNav />
                <div className="main-content-with-sidebar" style={{ flex: 1, backgroundColor: '#f8f9fa' }}>
                    <Outlet />
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default GerenciaLayout;
